<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Общая информация</h4>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Название старта">
                <v-select
                  v-model="startOption"
                  :placeholder="'Введите название старта'"
                  :close-on-select="true"
                  :options="startOptions"
                  :reduce="startOption => startOption"
                  label="label"
                  input-id="short_name"
                  :value="startOption"
                  class="select"
                  @search="(search, loading) => getStarts(search, loading)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Название альбома">
                <div class="flex-row">
                  <b-form-input
                    v-model="albumName"
                    placeholder="Введите название альбома"
                  />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <div class="flex-row">
                <b-form-checkbox
                  v-model="isBeforeStart"
                  type="checkbox"
                />
                <span>Альбом будет показан до начала старта</span>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Фотографии</h4>
      </div>
      <div class="card-body">
        <b-col
          md="6"
          style="padding-left: 0"
        >
          <b-tabs content-class="mt-1">
            <!-- Старый способ -->
            <b-tab
              title="Обычная загрузка"
              active
            >
              <div class="upload-wrap">
                <span>Загрузить фото</span>
                <multi-file-uploader
                  v-model="newFiles"
                  @updatePhotos="getPhotos"
                />
              </div>
            </b-tab>

            <!-- Новый способ -->
            <b-tab title="Пакетная загрузка">
              <div
                class="batch-dropzone"
                :class="{ 'is-dragover': batchDragOver }"
                @dragenter.prevent="batchDragOver = true"
                @dragover.prevent="batchDragOver = true"
                @dragleave.prevent="batchDragOver = false"
                @drop.prevent="onBatchDrop"
              >
                <div class="batch-dropzone__title">
                  Перетащите сюда фото или выберите файлы
                </div>

                <div class="batch-dropzone__actions">
                  <b-form-file
                    multiple
                    accept="image/*"
                    browse-text="Выбрать"
                    placeholder="Файлы не выбраны"
                    @change="onBatchPick"
                  />
                </div>

                <div
                  v-if="batchFiles.length"
                  class="batch-list"
                >
                  <div class="batch-list__header">
                    <div>
                      Выбрано: <b>{{ batchFiles.length }}</b>
                    </div>
                    <div class="batch-list__buttons">
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="clearBatch"
                        :disabled="batchUploading"
                      >
                        Очистить
                      </b-button>
                      <b-button
                        size="sm"
                        variant="primary"
                        @click="uploadBatch"
                        :disabled="batchUploading || !batchFiles.length"
                      >
                        Загрузить {{ batchFiles.length }}
                      </b-button>
                    </div>
                  </div>

                  <div class="batch-list__items">
                    <div
                      v-for="(f, i) in batchFiles"
                      :key="f.name + f.lastModified + i"
                      class="batch-item"
                    >
                      <img
                        class="batch-item__preview"
                        :src="f.__preview"
                        alt=""
                      />
                      <div class="batch-item__meta">
                        <div class="batch-item__name">{{ f.name }}</div>
                        <div class="batch-item__sub">
                          {{ prettyBytes(f.size) }} • lastModified:
                          {{ f.lastModified }}
                        </div>
                      </div>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="removeBatchFile(i)"
                        :disabled="batchUploading"
                      >
                        Удалить
                      </b-button>
                    </div>
                  </div>

                  <div
                    v-if="batchUploading"
                    class="mt-1"
                  >
                    <b-progress
                      :value="batchProgress"
                      max="100"
                      height="10px"
                    />
                    <div class="batch-progress-text">{{ batchProgress }}%</div>
                  </div>

                  <div
                    v-if="batchError"
                    class="batch-error"
                  >
                    {{ batchError }}
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
        <vue-selecto
          ref="selecto"
          drag-container=".images-container"
          :selectable-targets="['.selecto-area .card__wrapper']"
          :hit-rate="20"
          :select-by-click="true"
          :scroll-options="scrollOptions"
          :ratio="0"
          @dragStart="onDragStart"
          @select="onSelect"
          @scroll="onScroll"
        />
        <div
          id="selecto1"
          ref="scroller"
          :class="[
            'images-container',
            'scroll',
            'selecto-area',
            photos.length ? '' : 'hidden-container',
          ]"
          @scroll="onScrollerScroll"
        >
          <div
            v-for="(photo, index) in photos"
            :key="index"
            style="display: flex; flex-direction: column"
            class="photo-container"
          >
            <photo-item
              :album="album"
              :photo="photo"
              :hashtags="hashtags"
              @setSelectedPhoto="setSelectedPhoto"
              @deletePhoto="deletePhoto"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Теги для выбранных фотографий</h4>
      </div>
      <div
        v-if="hashtags.length > 0"
        class="tagWrap"
      >
        <div
          v-for="(item, index) in hashtags"
          :key="item + index"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Название тега">
                <div class="flex-row">
                  <div class="tag-suggest-wrap">
                    <b-form-input
                      v-model="tag"
                      placeholder="Введите тег для выбранных фотографий"
                      :disabled="checkedPhotos.length === 0"
                      autocomplete="off"
                      @focus="onTagFocus"
                      @blur="onTagBlur"
                      @keydown.esc="isTagDropdownOpen = false"
                      @keyup.enter="submit"
                    />
                    <div
                      v-if="isTagDropdownOpen && tagSuggestions.length"
                      class="tag-suggest-dropdown"
                    >
                      <button
                        v-for="item in tagSuggestions"
                        :key="item"
                        type="button"
                        class="tag-suggest-item"
                        @mousedown.prevent="selectTagSuggestion(item)"
                      >
                        {{ item }}
                      </button>
                    </div>
                  </div>
                  <b-spinner
                    v-if="isTagSearchLoading"
                    small
                    class="ml-1"
                  />
                  <plus-icon
                    size="1.5x"
                    class="cursor"
                    :class="{ 'disabled-icon': checkedPhotos.length === 0 }"
                    @click="submit"
                  />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1 save-button"
        :disabled="isloading"
        @click="saveItem"
      >
        <b-spinner
          v-if="isloading"
          small
        />
        {{ isloading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
  VBPopover,
  BFormCheckbox,
  BTabs,
  BTab,
  BProgress,
  BFormFile,
} from 'bootstrap-vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { XIcon, PlusIcon } from 'vue-feather-icons'
import vSelect from 'vue-select'
import { VueSelecto } from 'vue-selecto'
import MultiFileUploader from '@/global-components/MultiFileUploader'
import crudModule from '../../../libs/crud_module'
import PhotoItem from './Photo.vue'

const albumModule = crudModule({
  entity_name: 'album',
})
const startModule = crudModule({
  entity_name: 'start',
})
const albumPhotoModule = crudModule({
  entity_name: 'album/photo',
})

export default {
  name: 'AlbumPage',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    BFormCheckbox,
    ToastificationContent,
    XIcon,
    PlusIcon,
    MultiFileUploader,
    vSelect,
    VueSelecto,
    PhotoItem,
    BTabs,
    BTab,
    BProgress,
    BFormFile,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      isloading: false,
      file: {},
      hashtags: [],
      tag: '',
      tagSuggestions: [],
      isTagSearchLoading: false,
      tagSearchDebounceTimer: null,
      tagSearchSeq: 0,
      isTagDropdownOpen: false,
      tagBlurTimer: null,
      newFiles: null,
      photoIds: [],
      startOptions: [],
      startOption: {},
      photos: [],
      album: {},
      checkedPhotos: [],
      albumName: '',
      newPhotos: [],
      newPhotosIds: [],
      isBeforeStart: false,
      scrollOptions: {},
      batchFiles: [],
      batchUploading: false,
      batchProgress: 0,
      batchError: null,
      batchDragOver: false,
    }
  },
  computed: {
    startName() {
      if (this.album.start) {
        return this.album.start.short_name
      }
      return ''
    },
    fullPath(file) {
      if (file.fullPath) {
        return file.fullPath
      }
      return ''
    },
  },
  watch: {
    newFiles() {
      this.photoIds.push(this.newFiles)
    },
    tag(val) {
      this.debouncedFetchTagSuggestions(val)
    },
  },
  beforeDestroy() {
    if (this.tagSearchDebounceTimer) clearTimeout(this.tagSearchDebounceTimer)
    if (this.tagBlurTimer) clearTimeout(this.tagBlurTimer)
  },
  mounted() {
    this.scrollOptions = {
      container: this.$refs.scroller,
      throttleTime: 30,
      threshold: 0,
    }
  },
  methods: {
    onTagFocus() {
      if (this.tagBlurTimer) clearTimeout(this.tagBlurTimer)
      this.isTagDropdownOpen = true
      if (!this.tag.trim()) {
        this.fetchTagSuggestions('')
      }
    },
    onTagBlur() {
      // allow click on suggestion before input loses focus
      if (this.tagBlurTimer) clearTimeout(this.tagBlurTimer)
      this.tagBlurTimer = setTimeout(() => {
        this.isTagDropdownOpen = false
      }, 150)
    },
    selectTagSuggestion(val) {
      this.tag = val
      this.isTagDropdownOpen = false
    },
    onDragStart(e) {
      if (e.inputEvent.target.nodeName === 'BUTTON') {
        return false
      }
      return true
    },
    onSelect(e) {
      e.added.forEach(el => {
        el.classList.add('active')
        this.setSelectedPhoto(+el.id, [true])
      })
      e.removed.forEach(el => {
        el.classList.remove('active')
        this.setSelectedPhoto(+el.id, [false])
      })
    },
    onScroll(e) {
      this.$refs.scroller.scrollBy(e.direction[0] * 10, e.direction[1] * 10)
    },
    resetScroll() {
      this.$refs.scroller.scrollTo(0, 0)
    },
    onScrollerScroll() {
      this.$refs.selecto.checkScroll()
    },
    setPhotoIds(photos) {
      this.photoIds = photos.map(item => item.file_id)
    },
    setSelectedPhoto(value, checked) {
      if (checked[0]) {
        this.checkedPhotos.push(value)
      } else {
        const index = this.checkedPhotos.findIndex(id => id === value)
        if (index > -1) {
          this.checkedPhotos.splice(index, 1)
        }
      }
      
      // Обновляем отображаемые теги на основе выбранных фото
      this.hashtags = []
      if (this.checkedPhotos.length > 0) {
        const firstPhoto = this.photos.find(p => p.file.id === this.checkedPhotos[0])
        if (firstPhoto && firstPhoto.tags) {
          this.hashtags = [...firstPhoto.tags]
        }
      }
    },
    debouncedFetchTagSuggestions(val) {
      if (this.tagSearchDebounceTimer) clearTimeout(this.tagSearchDebounceTimer)

      const query = (val || '').trim()

      this.tagSearchDebounceTimer = setTimeout(() => {
        this.fetchTagSuggestions(query)
      }, 250)
    },
    async fetchTagSuggestions(filterText) {
      const client = this.$http || this.$axios
      if (!client) return

      const seq = ++this.tagSearchSeq
      this.isTagSearchLoading = true

      try {
        const params = {}
        const query = (filterText || '').trim()
        if (query) params.filterText = query

        const { data } = await client.get('albums-tags/photos/tags', { params })

        // ignore outdated responses (fast typing)
        if (seq !== this.tagSearchSeq) return

        const raw = Array.isArray(data)
          ? data
          : data?.items || data?.data || []

        this.tagSuggestions = (raw || [])
          .map(x => (typeof x === 'string' ? x : x?.name))
          .filter(Boolean)
          .slice(0, 20)
      } catch (e) {
        // silent: don't spam toasts on typing
        if (seq === this.tagSearchSeq) this.tagSuggestions = []
      } finally {
        if (seq === this.tagSearchSeq) this.isTagSearchLoading = false
      }
    },
    submit(e) {
      const tagName = (this.tag || '').trim()
      if (!tagName) return

      const newTag = { name: tagName }
      
      // Добавляем тег к выбранным фотографиям локально
      this.checkedPhotos.forEach(photoId => {
        const photo = this.photos.find(p => p.file.id === photoId)
        if (photo) {
          // Проверяем, нет ли уже такого тега
          const existingTag = photo.tags.find(t => t.name === newTag.name)
          if (!existingTag) {
            photo.tags.push(newTag)
          }
        }
      })
      
      // Обновляем отображаемые теги
      this.hashtags = []
      if (this.checkedPhotos.length > 0) {
        const firstPhoto = this.photos.find(p => p.file.id === this.checkedPhotos[0])
        if (firstPhoto && firstPhoto.tags) {
          this.hashtags = [...firstPhoto.tags]
        }
      }
      
      this.tag = ''
      this.tagSuggestions = []
      
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Уведомление',
          icon: 'BellIcon',
          text: 'Тег добавлен к выбранным фотографиям',
          variant: 'success',
        },
      })
    },
    saveItem() {
      this.createAlbum()
    },
    async createAlbum() {
      const newPhotos = this.photos.map(photo => ({
        file_id: photo.file.id,
        tags: photo.tags || [],
      }))

      try {
        const payload = {
          start_id: this.startOption.id,
          name: this.albumName,
          photos: newPhotos,
          isBeforeStart: this.isBeforeStart,
        }
        await albumModule
          .createItem(payload)
          .then(response => {
            console.log(this.response)
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Альбом добавлен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'albums' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    debounceSearch(search, loading, fn) {
      clearTimeout(this.debounce)
      if (search.length > 0) {
        this.debounce = setTimeout(fn, 600)
      }
    },
    getStarts(search, loading) {
      this.debounceSearch(search, loading, async () => {
        try {
          await startModule.fetchItems({ filterText: search }).then(result => {
            this.startOptions = result.data.rows.map(row => ({
              ...row,
              label: `${row.name} (${this.formatDate(row.start_date)})`,
            }))
            loading(false)
          })
        } catch (e) {
          console.error(e)
        }
      })
    },
    getPhotos(data) {
      const fileForPhoto = {
        file: data,
        tags: [],
      }
      this.photos.push(fileForPhoto)
    },
    deletePhoto(photo) {
      const index = this.checkedPhotos.findIndex(id => id === photo.file.id)
      if (index > -1) {
        this.checkedPhotos.splice(index, 1)
      }

      this.photos = this.photos.filter(item => item.file.id !== photo.file.id)
      this.photoIds = this.photoIds.filter(item => item !== photo.file.id)
    },
    updatePhoto(photo) {
      const photosArr = [...this.photos]
      const index = photosArr.findIndex(item => item.file.id === photo.file.id)
      if (index >= 0) {
        photosArr[index] = photo
        this.photos = photosArr
      }
    },
    formatDate(date) {
      if (date) {
        const newDate = new Date(date)
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const newStr = newDate.toLocaleDateString('ru', options)
        return newStr
      }
      return ''
    },
    //    async uploadBatch() {
    //   if (!this.batchFiles.length) return

    //   this.batchUploading = true
    //   this.batchProgress = 0
    //   this.batchError = null

    //   try {
    //     const form = new FormData()

    //     this.batchFiles.forEach(f => {
    //       form.append('files', f, f.name)
    //     })

    //     form.append('lastModified', String(Date.now()))

    //     const client = this.$http || this.$axios

    //     const res = await client.post('file/upload-batch', form, {
    //       headers: { 'Content-Type': 'multipart/form-data' },
    //       onUploadProgress: e => {
    //         if (!e.total) return
    //         this.batchProgress = Math.round((e.loaded * 100) / e.total)
    //       },
    //     })

    //     const uploaded = Array.isArray(res.data) ? res.data : (res.data?.files || [])
    //     uploaded.forEach(fileObj => this.getPhotos(fileObj))

    //     this.clearBatch()
    //     this.resetScroll()
    //   } catch (e) {
    //     this.batchError = e?.response?.data?.message || 'Ошибка пакетной загрузки'
    //   } finally {
    //     this.batchUploading = false
    //   }
    // },
    async uploadBatch() {
      if (!this.batchFiles.length) return

      const CHUNK_SIZE = 20 // 15-30 обычно оптимально
      const chunks = []
      for (let i = 0; i < this.batchFiles.length; i += CHUNK_SIZE) {
        chunks.push(this.batchFiles.slice(i, i + CHUNK_SIZE))
      }

      this.batchUploading = true
      this.batchProgress = 0
      this.batchError = null

      try {
        const total = this.batchFiles.length
        let uploadedCount = 0

        for (const part of chunks) {
          const form = new FormData()

          // files как "массив" бинарников
          part.forEach(f => form.append('files', f, f.name))

          // lastModified по вашему контракту: одно значение, текущая дата
          form.append('lastModified', String(Date.now()))

          const client = this.$http || this.$axios

          const res = await client.post('file/upload-batch', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: e => {
              // прогресс внутри чанка
              if (!e.total) return
              const chunkPct = (e.loaded * 100) / e.total

              // переводим в общий прогресс
              const base = (uploadedCount * 100) / total
              const partWeight = (part.length * 100) / total
              this.batchProgress = Math.min(
                99,
                Math.round(base + (chunkPct / 100) * partWeight),
              )
            },
          })

          const uploaded = Array.isArray(res.data)
            ? res.data
            : res.data?.files || []
          uploaded.forEach(fileObj => this.getPhotos(fileObj))

          uploadedCount += part.length
          this.batchProgress = Math.round((uploadedCount * 100) / total)
        }

        this.clearBatch()
        this.resetScroll()
      } catch (e) {
        this.batchError =
          e?.response?.data?.message || 'Ошибка пакетной загрузки'
      } finally {
        this.batchUploading = false
      }
    },
    onBatchPick(evt) {
      const files = Array.from(evt?.target?.files || [])
      this.addBatchFiles(files)
    },

    onBatchDrop(evt) {
      this.batchDragOver = false
      const files = Array.from(evt?.dataTransfer?.files || [])
      this.addBatchFiles(files)
    },

    addBatchFiles(files) {
      this.batchError = null
      const onlyImages = files.filter(
        f => f && f.type && f.type.startsWith('image/'),
      )

      const key = f => `${f.name}_${f.lastModified}_${f.size}`
      const existing = new Set(this.batchFiles.map(key))

      const prepared = onlyImages
        .filter(f => !existing.has(key(f)))
        .map(f => {
          f.__preview = URL.createObjectURL(f)
          return f
        })

      this.batchFiles = [...this.batchFiles, ...prepared]
    },

    removeBatchFile(i) {
      const f = this.batchFiles[i]
      if (f?.__preview) URL.revokeObjectURL(f.__preview)
      this.batchFiles.splice(i, 1)
    },

    clearBatch() {
      this.batchFiles.forEach(f => {
        if (f?.__preview) URL.revokeObjectURL(f.__preview)
      })
      this.batchFiles = []
      this.batchProgress = 0
      this.batchError = null
    },

    prettyBytes(bytes) {
      if (!Number.isFinite(bytes)) return ''
      const units = ['B', 'KB', 'MB', 'GB']
      let i = 0
      let v = bytes
      while (v >= 1024 && i < units.length - 1) {
        v /= 1024
        i++
      }
      return `${v.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
    },
  },
}
</script>

<style scoped lang="scss">
.save-button {
  position: fixed !important;
  bottom: 30px;
  right: 15px;
  z-index: 1000;
  margin-top: 20px !important;
}
.tagWrap {
  margin: 20px;
  margin-bottom: 0px;
  display: flex;
  gap: 10px;
}
.cursor {
  cursor: pointer;
}

.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.disabled-container {
  opacity: 0.6;
  pointer-events: none;
  user-select: none;
}

.flex-row {
  display: flex;
  gap: 20px;
  align-items: center;
}

.tag-suggest-wrap {
  position: relative;
  flex: 1 1 auto;
}

.tag-suggest-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  z-index: 2000;
  background: #fff;
  border: 1px solid rgba(34, 41, 47, 0.15);
  border-radius: 0.358rem;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.12);
  max-height: 220px;
  overflow: auto;
  padding: 6px 0;
}

.tag-suggest-item {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 8px 12px;
  text-align: left;
  color: #5e5873;
  cursor: pointer;
}

.tag-suggest-item:hover,
.tag-suggest-item:focus {
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  outline: none;
}

.dark-layout .tag-suggest-dropdown {
  background: #161d31;
  border-color: rgba(255, 255, 255, 0.12);
}

.dark-layout .tag-suggest-item {
  color: #d0d2d6;
}

.dark-layout .tag-suggest-item:hover,
.dark-layout .tag-suggest-item:focus {
  background: rgba(115, 103, 240, 0.22);
  color: #fff;
}
.upload-wrap {
  margin-bottom: 20px;
}
.scroll {
  overflow: auto;
  height: 510px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.images-container {
  display: flex;
  flex-direction: row;
  gap: 40px;
  flex-wrap: wrap;
}
.hidden-container {
  display: none;
}

.dark-layout .batch-dropzone {
  background: #161d31;
}

.dark-layout .batch-item {
  background: #161d31;
}

.batch-dropzone {
  border: 1px dashed #c7c7c7;
  border-radius: 12px;
  padding: 14px;
  background: #fafafa;
  margin-bottom: 1rem;
}

.batch-dropzone.is-dragover {
  background: #f1f5ff;
  border-color: #5b8def;
}

.batch-dropzone__title {
  font-weight: 600;
  margin-bottom: 10px;
}

.batch-dropzone__actions {
  margin-bottom: 12px;
}

.batch-list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.batch-list__buttons {
  display: flex;
  gap: 8px;
}

.batch-list__items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: scroll;
}

.batch-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border: 1px solid #eee;
  border-radius: 10px;
  background: #fff;
}

.batch-item__preview {
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.batch-item__meta {
  flex: 1;
  min-width: 0;
}

.batch-item__name {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.batch-item__sub {
  font-size: 12px;
  opacity: 0.75;
}

.batch-progress-text {
  font-size: 12px;
  margin-top: 6px;
  opacity: 0.8;
}

.batch-error {
  margin-top: 10px;
  color: #b42318;
  background: #fff1f0;
  border: 1px solid #ffd6d6;
  padding: 8px 10px;
  border-radius: 10px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
